export class MessageToPublish {
    constructor(sound, source) {
        this.sound = sound;
        this.source = source;
        this.client = "web";
    }
}